import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { importGuestDraftIfAny } from "../lib/guestFlow";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
    redirectUrl,
  )}`;
}

export default function Register() {
  const { register: registerUser } = useAuth();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm();
  const [serverError, setServerError] = useState("");

  const onSubmit = async (values) => {
    setServerError("");
    try {
      await registerUser(values);
      const imported = await importGuestDraftIfAny();
      if (imported) {
        toast.success("Account created — your biodata is now your profile!");
        navigate("/profile/edit");
      } else {
        toast.success("Account created!");
        navigate("/dashboard");
      }
    } catch (e) {
      setServerError(formatApiError(e));
    }
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5" style={{ maxWidth: 520 }}>
        <div className="sb-card" data-testid="register-card">
          <div className="sb-kicker mb-2">Get started</div>
          <h1 className="h2 mb-4">Create your matrimonial profile.</h1>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <div className="mb-3">
              <label className="form-label">Full name</label>
              <input
                className="form-control"
                autoComplete="name"
                data-testid="register-name"
                {...register("name", { required: "Name is required" })}
              />
              {errors.name && <div className="text-danger small mt-1">{errors.name.message}</div>}
            </div>
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                autoComplete="email"
                data-testid="register-email"
                {...register("email", { required: "Email is required" })}
              />
              {errors.email && <div className="text-danger small mt-1">{errors.email.message}</div>}
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                className="form-control"
                autoComplete="new-password"
                data-testid="register-password"
                {...register("password", {
                  required: "Password is required",
                  minLength: { value: 6, message: "At least 6 characters" },
                })}
              />
              {errors.password && (
                <div className="text-danger small mt-1">{errors.password.message}</div>
              )}
            </div>

            {serverError && (
              <div className="alert alert-danger py-2" data-testid="register-error">
                {serverError}
              </div>
            )}

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={isSubmitting}
              data-testid="register-submit"
            >
              {isSubmitting ? "Creating account…" : "Create account"}
            </button>
          </form>

          <div className="text-center my-3 text-muted small">or</div>

          <button
            type="button"
            onClick={startGoogleLogin}
            className="btn btn-outline-primary w-100"
            data-testid="register-google"
          >
            Continue with Google
          </button>

          <div className="text-center mt-4 small">
            Already have an account?{" "}
            <Link to="/login" className="sb-link-quiet" data-testid="link-login">
              Sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
